import './Loading.css';
import loading from "assets/img/spinner.gif";

function Loading() {
  return (
    <div className="loading-overlay">
      <img src={loading} alt="Loading" className="loading-spinner" />
      <p><b>Obteniendo datos de usuario...</b></p>
    </div>
  );
}

export default Loading;
